import axios from 'axios';

import { UcrService, serviceOptions } from './__generated__';
import { clearEmptyParamsInterceptor } from './interceptors/clearEmptyParams';
import { has401Interceptor } from './interceptors/has401';
import { hasAnyCodeInterceptor } from './interceptors/hasAnyCode';
import { xRequestIdInterceptor } from './interceptors/xRequestId';

const baseURL = import.meta.env.__UCR_API_URL__;

const instance = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// request
xRequestIdInterceptor(instance.interceptors.request);
clearEmptyParamsInterceptor(instance.interceptors.request);

// response
has401Interceptor(instance.interceptors.response);

hasAnyCodeInterceptor(
  500,
  '/manage/server-error',
  new Set(['/login']),
)(instance.interceptors.response);

hasAnyCodeInterceptor(
  502,
  '/manage/server-error',
  new Set(['/login']),
)(instance.interceptors.response);

serviceOptions.axios = instance;

export const apiClient = UcrService;
